// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutButton_wrapper__e0QA3","basket":"CheckoutButton_basket__j9PA3","count":"CheckoutButton_count__M6l7o"};